import { updateOneVersion } from 'serviceWorker/db/documentations/documentations';
import { UploadStatus } from 'shared/types/uploadStatus';

type SetUploadStatus = (localId: number, versionId: string, uploadStatus: UploadStatus) => Promise<number>;

/** The upload state of one version; the documentation's other versions stay as they are. */
export const setUploadStatus: SetUploadStatus = (localId, versionId, uploadStatus) =>
  updateOneVersion(localId, versionId, { uploadStatus });
